module.exports = __webpack_public_path__ + "img/w-booking_steps.ff711cd9.png";